var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 2h4a7 7 0 0 1 7 7v9H5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 14h2v2h-2zM14.25 10h2v2h-2zM7 16.75h7v2H7z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h20v20H0z",
  style: {
    mixBlendMode: "multiply"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M13.75 16.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M18.61 14.674a5.4 5.4 0 0 0-4.86-3.424 5.4 5.4 0 0 0-4.86 3.424L8.75 15l.14.326a5.4 5.4 0 0 0 4.86 3.424 5.4 5.4 0 0 0 4.86-3.424l.14-.326zM13.75 17.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M7.5 17.5H5v-15h5v3.75a1.254 1.254 0 0 0 1.25 1.25H15V10h1.25V6.25a.57.57 0 0 0-.187-.438l-4.375-4.375a.57.57 0 0 0-.438-.187H5A1.254 1.254 0 0 0 3.75 2.5v15A1.254 1.254 0 0 0 5 18.75h2.5zm3.75-14.75 3.5 3.5h-3.5z"
})));
export default SvgDocumentation;